class checker {
    constructor(sweetalert, logger) {
        this.sweetalert = sweetalert
        this.logger = logger
    }
    checkBuyerCreditCode(val, type) {
        return new Promise((resolve, reject) => {
            if ((type == 3 || type == 2) && !val) {
                // 个人或非企业单位不校验税号
                resolve()
            } else if (/^([0-9A-Z]{6,20})$/.test(val)) {
                if (/^([0-9A-Z]{15}|[0-9A-Z]{17}|[0-9A-Z]{18}|[0-9A-Z]{20})$/.test(val)) {
                    resolve()
                } else {
                    this.sweetalert.confirm('操作提醒', ' 购买方纳税人识别号非15、17、18、20位，请确认税号是否正确，是否继续？').then(() => {
                        resolve()
                    }, () => {
                        reject()
                    })
                }
            } else {
                this.logger.logError('购方税号必须是6~20位大写字母或数字')
                reject()
            }
        })
    }
}

checker.$inject = ['sweetalert', 'logger']
export default checker;



// WEBPACK FOOTER //
// ./src/common/services/checkBuyerCreditCode.js